// combatpro/shell/CombatDock.js
//
// Combat PRO - sticky Combat Control Dock.
//
// A deliberately thin, full-width live bar at the top of Combat PRO so the DM can check
// the working context and drive the critical live actions from anywhere on a long page
// without scrolling back up. It is NOT a second control system: it reads and calls the
// exact same CombatContext state and handlers as the normal controls, so the two
// surfaces are always in sync.
//
// Layout authority (2026-10-06): the bar is rendered as the FIRST element of .cp-root
// and is position: sticky (combatProTheme.css), i.e. it sits in normal document flow.
// Its real, responsive height is therefore always reserved above the page, so the
// header, title and every page begin BELOW it at every width, and it stays pinned to
// the top while scrolling. (Previously it was position: fixed with no reserved space
// and was shown whenever an end-of-shell sentinel was off screen, which on any shell
// taller than the window meant it covered the header and title from first load.)
// No optional chaining, no nullish coalescing, no em dash.

import React, { useContext } from 'react';
import { CombatContext } from '../contexts/CombatContext';

function dockMonsterName(m, i) {
  if (!m) { return 'Monster ' + (i + 1); }
  var cn = (m.customName && String(m.customName).trim()) ? String(m.customName).trim() : '';
  var sm = (m.selectedMonster && String(m.selectedMonster).trim()) ? String(m.selectedMonster).trim() : '';
  return (cn || sm || ('Monster ' + (i + 1)));
}

function CombatDock(props) {
  const { state, nextCombatant, prevCombatant, nextRound, prevRound, createSnapshot } = useContext(CombatContext);

  const store = state.encounterStore;
  const ai = (store && typeof store.activeIndex === 'number') ? store.activeIndex : 0;
  const encs = (store && Array.isArray(store.encounters)) ? store.encounters : [];
  const encName = (encs[ai] && encs[ai].meta && encs[ai].meta.name) ? encs[ai].meta.name : ('Encounter ' + (ai + 1));
  const mi = state.currentCombatantIndex;
  const monster = Array.isArray(state.monsters) ? state.monsters[mi] : null;

  return (
    <div className="vi-combat-dock" role="toolbar" aria-label="Combat quick controls">
      <div className="vi-dock-ctx">
        <span className="vi-dock-chip"><span className="vi-dock-k">Enc</span> {encName}</span>
        <span className="vi-dock-chip"><span className="vi-dock-k">Monster</span> {dockMonsterName(monster, mi)}</span>
        <span className="vi-dock-chip"><span className="vi-dock-k">Round</span> {state.currentRound}</span>
      </div>
      <div className="vi-dock-actions">
        <button type="button" className="vi-dock-btn" onClick={prevRound} title="Previous round" aria-label="Previous round">{'⏮'} Rnd</button>
        <button type="button" className="vi-dock-btn" onClick={nextRound} title="Next round" aria-label="Next round">Rnd {'⏭'}</button>
        <button type="button" className="vi-dock-btn" onClick={prevCombatant} title="Previous combatant" aria-label="Previous combatant">{'⏮'} Turn</button>
        <button type="button" className="vi-dock-btn" onClick={nextCombatant} title="Next combatant" aria-label="Next combatant">Turn {'⏭'}</button>
        <button type="button" className="vi-dock-btn vi-dock-btn-gold" onClick={props.onOpenTreasure} title="Treasure for the active monster" aria-label="Treasure">{'💰'} Treasure</button>
        <button type="button" className="vi-dock-btn" onClick={function () { createSnapshot(true); }} title="Take a snapshot" aria-label="Snapshot">{'📸'} Snapshot</button>
      </div>
    </div>
  );
}

export default CombatDock;
